export const STOCK_IVA_RATE = 0.19;

export const parseStockNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const positiveNumber = (value) => {
  const parsed = parseStockNumber(value);
  return parsed && parsed > 0 ? parsed : 0;
};

export const calculateStockAmounts = (stock = {}) => {
  const price = positiveNumber(stock.price);
  const priceWithoutIva = positiveNumber(stock.priceWithoutIva);
  const quantity = positiveNumber(stock.quantity);
  const providerUnitAmount = price + priceWithoutIva;
  const ivaUnitUpliftAmount = priceWithoutIva * STOCK_IVA_RATE;
  const stockCostUnitAmount = providerUnitAmount + ivaUnitUpliftAmount;
  const providerTotalAmount = providerUnitAmount * quantity;
  const ivaCostUpliftAmount = ivaUnitUpliftAmount * quantity;
  const stockCostAmount = stockCostUnitAmount * quantity;

  return {
    price,
    priceWithoutIva,
    quantity,
    providerUnitAmount,
    stockCostUnitAmount,
    providerTotalAmount,
    stockCostAmount,
    ivaCostUpliftAmount,
  };
};

export const resolveProviderTotalAmount = (stock = {}) => {
  const provided = parseStockNumber(stock.providerTotalAmount ?? stock.totalAmount);
  return provided !== null ? provided : calculateStockAmounts(stock).providerTotalAmount;
};

export const resolveStockCostAmount = (stock = {}) => {
  const provided = parseStockNumber(stock.stockCostAmount);
  return provided !== null ? provided : calculateStockAmounts(stock).stockCostAmount;
};

export const resolveIvaCostUpliftAmount = (stock = {}) => {
  const provided = parseStockNumber(stock.ivaCostUpliftAmount);
  return provided !== null ? provided : calculateStockAmounts(stock).ivaCostUpliftAmount;
};
